export default __webpack_public_path__ + "static/media/facebook.65c4bee2.webp";